import './App.css';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import Scan from './components/Scan';
import SignIn from './components/SignIn';
function RequireAuth({children}){
  return localStorage.getItem("status") == 'true' ? children : <Navigate to="/" replace/>;
}
function App() {
  return (
    <div>
    <Router>
      <Routes>
        <Route path="/scan" element={
          <RequireAuth>
            <Scan />
          </RequireAuth>
        } />
        <Route path="/" element={<SignIn />} />
      </Routes>
      </Router>
    </div>
  );
}
export default App;
